import { WSTable } from "@wingspanhq/fe-component-library";
import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { columns } from "./columns";

type Props = {
  workLogs: IWorkLog[];
  onRowClick?: (workLog: IWorkLog) => void;
};

export type TableItemData = IWorkLog;

export const TableWorkLogsPayerView: React.FC<Props> = props => {
  const tableData = useMemo(() => {
    return props.workLogs.map(workLog => ({
      id: workLog.workLogId,
      data: workLog
    }));
  }, [props.workLogs]);

  const handleRowClick = props.onRowClick
    ? (item: { id: string; data: IWorkLog }) => props.onRowClick!(item.data)
    : undefined;

  return (
    <WSTable<TableItemData>
      tableData={tableData}
      columns={columns}
      onRowClick={handleRowClick}
    />
  );
};
